import React from 'react';
import { photos } from '../data/site';
type LogoProps = {
  variant?: 'light' | 'dark';
  className?: string;
};
export function Logo({
  variant = 'light',
  className = ''
}: LogoProps) {
  if (variant === 'dark') {
    return <span className={`inline-flex flex-col leading-none ${className}`} data-id="element-222" data-mp="3qaw22qrajw9s">
        <span className="flex items-baseline gap-1.5" data-id="element-223" data-mp="3v7wcfdv6bl6p">
          <span className="font-display italic text-2xl font-semibold text-white" data-id="element-224" data-mp="3v6bgbjt7nu6q">
            Premier
          </span>
          <span className="h-2 w-2 bg-green" aria-hidden="true" data-id="element-225" data-mp="rrp7z54xpjwv" />
        </span>
        <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.18em] text-green-light" data-id="element-226" data-mp="rpl6suyf6z0a">
          Advisory Services Ltd
        </span>
      </span>;
  }
  return <img src={photos.logo} alt="Premier Advisory Services Ltd" className={`h-11 w-auto object-contain ${className}`} data-id="element-227" data-mp="hrybwz0q6wuo" />;
}